import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// ===== Redesign (Claude Design implementation) — native React pages =====
// Public pages
import RHomePage from "./redesign/pages/RHomePage";
import RCooberPedyPage from "./redesign/pages/RCooberPedyPage";
import RFreeMuseumPage from "./redesign/pages/RFreeMuseumPage";
import RUndergroundToursPage from "./redesign/pages/RUndergroundToursPage";
import RGroupToursPage from "./redesign/pages/RGroupToursPage";
import RGroupAccommodationPage from "./redesign/pages/RGroupAccommodationPage";
import RAboutOpalPage from "./redesign/pages/RAboutOpalPage";
import ROpalStorePage from "./redesign/pages/ROpalStorePage";
import RWebcamPage from "./redesign/pages/RWebcamPage";
import RContactPage from "./redesign/pages/RContactPage";
import ROnlineStorePage from "./redesign/pages/ROnlineStorePage";
import RBookTourPage from "./redesign/pages/RBookTourPage";
import RProductDetailPage from "./redesign/pages/RProductDetailPage";
import RCheckoutPage from "./redesign/pages/RCheckoutPage";
// Admin screens
import RAdminLogin from "./redesign/admin/RAdminLogin";
import RManagerLogin from "./redesign/admin/RManagerLogin";
import RAdminDashboard from "./redesign/admin/RAdminDashboard";
import RAdminOrders from "./redesign/admin/RAdminOrders";
import RAdminProducts from "./redesign/admin/RAdminProducts";
import RAdminProductForm from "./redesign/admin/RAdminProductForm";
import RAdminCategories from "./redesign/admin/RAdminCategories";
import RAdminBookings from "./redesign/admin/RAdminBookings";
import RAdminLiveDashboard from "./redesign/admin/RAdminLiveDashboard";
import RAdminBlackoutDates from "./redesign/admin/RAdminBlackoutDates";
import RAdminUsers from "./redesign/admin/RAdminUsers";
import RAdminSettings from "./redesign/admin/RAdminSettings";
import RAdminAnalytics from "./redesign/admin/RAdminAnalytics";
import RAdminAppNotifications from "./redesign/admin/RAdminAppNotifications";

// ===== Legacy functional pages (no redesign exists for these yet) =====
import TourBookingSuccessPage from "./pages/TourBookingSuccessPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import CheckoutCancelledPage from "./pages/CheckoutCancelledPage";
import NotFoundPage from "./pages/NotFoundPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingSocialMedia from "./components/FloatingSocialMedia";
import UndergroundEdge from "./components/UndergroundEdge";
import HolidayClosurePopup from "./components/HolidayClosurePopup";
import { CartProvider } from "./contexts/CartContext";
import { AdminToastProvider } from "./redesign/AdminToast";

function App() {
  // Disable browser's automatic scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <HelmetProvider>
      <CartProvider>
      <AdminToastProvider>
        <div className="App">
          <BrowserRouter>
          {/* Holiday Closure Popup - Auto-removes after Jan 9, 2026 */}
          <HolidayClosurePopup />
          <ScrollToTop />
          <Routes>
            {/* ===== Admin (redesigned) ===== */}
            <Route path="/admin/login" element={<RAdminLogin />} />
            <Route path="/manager" element={<RManagerLogin />} />
            <Route path="/admin/dashboard" element={<RAdminDashboard />} />
            <Route path="/admin/orders" element={<RAdminOrders />} />
            <Route path="/admin/products" element={<RAdminProducts />} />
            <Route path="/admin/products/new" element={<RAdminProductForm />} />
            <Route path="/admin/products/:productId/edit" element={<RAdminProductForm />} />
            <Route path="/admin/users" element={<RAdminUsers />} />
            <Route path="/admin/bookings" element={<RAdminBookings />} />
            <Route path="/admin/live-dashboard" element={<RAdminLiveDashboard />} />
            <Route path="/admin/settings" element={<RAdminSettings />} />
            <Route path="/admin/blackout-dates" element={<RAdminBlackoutDates />} />
            <Route path="/admin/categories" element={<RAdminCategories />} />
            <Route path="/admin/analytics" element={<RAdminAnalytics />} />
            <Route path="/admin/app-notifications" element={<RAdminAppNotifications />} />

            {/* ===== Public (redesigned, self-contained shell) ===== */}
            <Route path="/" element={<RHomePage />} />
            <Route path="/coober-pedy" element={<RCooberPedyPage />} />
            <Route path="/free-museum" element={<RFreeMuseumPage />} />
            <Route path="/underground-tours" element={<RUndergroundToursPage />} />
            <Route path="/group-tours" element={<RGroupToursPage />} />
            <Route path="/group-accommodation" element={<RGroupAccommodationPage />} />
            <Route path="/book-tour" element={<RBookTourPage />} />
            <Route path="/opal-store" element={<ROpalStorePage />} />
            <Route path="/online-store" element={<ROnlineStorePage />} />
            <Route path="/opal-store/product/:productId" element={<RProductDetailPage />} />
            <Route path="/checkout" element={<RCheckoutPage />} />
            <Route path="/about-opal" element={<RAboutOpalPage />} />
            <Route path="/webcam" element={<RWebcamPage />} />
            <Route path="/contact" element={<RContactPage />} />

            {/* ===== Remaining functional pages keep the existing shell ===== */}
            <Route path="/*" element={
              <>
                <Header />
                <main className="min-h-screen">
                  <Routes>
                    <Route path="/tour-booking-success" element={<TourBookingSuccessPage />} />
                    <Route path="/opal-store/checkout" element={<CheckoutPage />} />
                    <Route path="/opal-store/checkout/success" element={<CheckoutSuccessPage />} />
                    <Route path="/opal-store/checkout/cancelled" element={<CheckoutCancelledPage />} />

                    {/* 404 Catch-all route */}
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </main>
                <Footer />
                <FloatingSocialMedia />
                <UndergroundEdge />
              </>
            } />
          </Routes>
        </BrowserRouter>
      </div>
      </AdminToastProvider>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
